import { createTheme } from '@mantine/core';
import { betaColors, seriesColors } from './tokens';

const betaTheme = createTheme({
  primaryColor: 'accent',
  colors: {
    ...betaColors,
  },
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Noto Sans JP", "Noto Sans SC", sans-serif',
  fontFamilyMonospace:
    'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, "Liberation Mono", monospace',
  respectReducedMotion: true,
  /* 'auto' emitted a 3px black ring on inputs and a 3px #d97706 ring on
     buttons, contradicting DESIGN.md's mandated 2px --beta-focus ring. 'never'
     hands focus indication to .beta-root :focus-visible in beta.css, which is
     the single source of truth for every focusable in the beta. */
  focusRing: 'never',
  defaultRadius: 'sm',
  radius: {
    xs: '2px',
    sm: '4px',
    md: '6px',
    lg: '8px',
    xl: '12px',
  },
  headings: {
    fontFamily: 'inherit',
    fontWeight: '700',
    sizes: {
      h1: { fontSize: '30px', lineHeight: '1.2', fontWeight: '700' },
      h2: { fontSize: '24px', lineHeight: '1.25', fontWeight: '700' },
      h3: { fontSize: '20px', lineHeight: '1.3', fontWeight: '600' },
      h4: { fontSize: '17px', lineHeight: '1.4', fontWeight: '600' },
      h5: { fontSize: '15px', lineHeight: '1.45', fontWeight: '600' },
      h6: { fontSize: '14px', lineHeight: '1.5', fontWeight: '600' },
    },
  },
  shadows: {
    xs: '0 1px 2px rgba(15, 23, 42, 0.05)',
    sm: '0 1px 3px rgba(15, 23, 42, 0.08)',
    md: '0 4px 12px rgba(15, 23, 42, 0.1)',
    lg: '0 8px 24px rgba(15, 23, 42, 0.12)',
    xl: '0 16px 40px rgba(15, 23, 42, 0.16)',
  },
  components: {
    Button: {
      styles: {
        root: {
          fontWeight: 600,
          // NOTE: the amber filled-button contrast is handled in beta.css by
          // overriding `--mantine-color-accent-filled`. Mantine writes
          // `--button-bg: var(--mantine-color-accent-filled)` as an *inline*
          // style on every Button, so no stylesheet rule can override it — the
          // token itself has to move (#d97706 → 3.19:1 with white text).
        },
      },
    },
    Input: {
      styles: {
        root: {
          borderRadius: '6px',
        },
      },
    },
  },
  other: {
    seriesColors,
  } as never,
});

export default betaTheme;
